export const calendarMonth_January = "_pa";
export default {calendarMonth_January};